import moment from "moment";
import StatusBadge from "../../../components/common/StatusBadge";
const defaultRender = (value) => (value ? value : "--");

const documentColumn = [
  {
    title: "Name",
    dataIndex: "original_name",
    render: (value) => <p className="text-primary">{value}</p>,
  },
  {
    title: "Date",
    dataIndex: "created_at",
    render: (value) => moment(value).format("lll") || "--",
  },
];

const signatureColumn = [
  {
    title: "Name",
    dataIndex: "original_name",
    render: (value) => <p className="text-primary">{value}</p>,
  },
  {
    title: "File Name",
    dataIndex: "fileName",
    render: (value) => <p className="capitalize">{value}</p>,
  },
  {
    title: "File Number",
    dataIndex: "fileNumber",
    render: defaultRender,
  },
  {
    title: "Date",
    dataIndex: "created_at",
    render: (value) => moment(value).format("lll") || "--",
  },
  {
    title: "Source",
    dataIndex: "sign_source",
    render: (value) => (value ? <StatusBadge status={value} /> : "--"),
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (value) => (
      <p
        className={`font-bold uppercase ${
          value === "signed" ? "text-green-500" : "text-red-500"
        }`}
      >
        {value}
      </p>
    ),
  },
];

const fileColumns = [
  {
    title: "File Name",
    dataIndex: "service_name_slug",
    render: (value) => <p className="capitalize">{value}</p>,
  },
  {
    title: "File Number",
    dataIndex: "file_number",
    render: defaultRender,
  },
  {
    title: "E-File Ack No",
    dataIndex: "acknowledge_ment_no",
    render: defaultRender,
  },
  {
    title: "E-File Ack Doc",
    dataIndex: "acknowledgement_doc",
    render: defaultRender,
  },
  {
    title: "Date",
    dataIndex: "created_at",
    render: (value) => moment(value).format("lll") || "--",
    width: 300,
  },
  {
    title: "Currently Processing",
    dataIndex: "running_task_name",
    render: defaultRender,
  },
  {
    title: "Progress",
    dataIndex: "progress",
    render: defaultRender,
    width: 300,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (value) => <StatusBadge status={value} />,
  },
];

const invoiceColumns = [
  {
    title: "File Name",
    dataIndex: "fileName",
    render: (value) => <p className="capitalize">{value}</p>,
  },
  {
    title: "File Number",
    dataIndex: "fileNumber",
    render: defaultRender,
  },
  {
    title: "Amount",
    dataIndex: "total_amount",
    render: (value) => {
    const num = Number(value);
    return <span>${!isNaN(num) ? num.toFixed(2) : "0.00"}</span>;
    },
  },
  {
    title: "Date",
    dataIndex: "created_at",
    render: (value) => moment(value).format("lll") || "--",
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (value) => (
      <p
        className={`font-bold uppercase ${
          value === "paid" ? "text-green-500" : "text-red-500"
        }`}
      >
        {value}
      </p>
    ),
  },
  {
    title: "Action",
    dataIndex: "action",
    render: defaultRender,
    fixed: 'right',
  },
];

const recentActivityColumn = [
  {
    title: "Activity",
    dataIndex: "activity",
    render: defaultRender,
  },
  {
    title: "Message",
    dataIndex: "message",
    render: defaultRender,
  },
  {
    title: "Date",
    dataIndex: "created_at",
    render: (value) => moment(value).format("lll") || "--",
  },
];

export {
  documentColumn,
  fileColumns,
  signatureColumn,
  invoiceColumns,
  recentActivityColumn,
};
